// ============================================================
// A CONTACT CLOSING IN (plan design-gaps, Z2; the ruling: "only the GM moves
// them - the display shows the state and a suggested spot", and "a contact
// closing in stops at reach, never on top of its target"). When a watcher is
// answered SEEN, the GM is offered the move that follows: it closes on the
// one it saw and stops beside them, in reach. Offered, never made.
//
// Pure. Zero React dependency. Metres.
// ============================================================

import type { Token } from '../battlefield/tokens';

/** The gap a closing figure leaves, footprint to footprint: a hand's breadth inside a metre's reach. */
const HAND_M = 0.3;

/** A proposed close-in: who moves, toward whom, where they would stop, and how far that is. */
export interface CloseIn {
  moverId: string;
  towardId: string;
  at: { x: number; z: number };
  metres: number;
}

/**
 * Where `mover` would stop closing on `toward`: on the line between them, its footprint a hand's breadth from
 * theirs (1.3 m apart for two men). Null when it is already that close - there is nothing to propose.
 */
export function closeIn(mover: Token, toward: Token): CloseIn | null {
  const dx = mover.x - toward.x;
  const dz = mover.z - toward.z;
  const apart = Math.hypot(dx, dz);
  const stop = mover.footprint + toward.footprint + HAND_M;
  if (apart <= stop) return null;
  const at = { x: toward.x + (dx / apart) * stop, z: toward.z + (dz / apart) * stop };
  return { moverId: mover.id, towardId: toward.id, at, metres: apart - stop };
}
